"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masterBulkImportCompletedPayloadSchema = exports.masterDeactivatedPayloadSchema = exports.MasterDataEventNames = void 0;
/**
 * Domain event names + payload schemas for the Master Data Platform
 * (Stage 3). Two generic, cross-cutting events rather than one pair per
 * entity (that would mean 24 near-identical event definitions across 12
 * masters) — `entityType` in the payload tells a subscriber which master
 * fired it. A future business module (e.g. Stage 12 Billing reacting to
 * a PayerMaster being deactivated) subscribes once and switches on
 * `entityType`, rather than the Master Data Platform needing to know in
 * advance every future module that might care.
 */
const zod_1 = require("zod");
exports.MasterDataEventNames = {
    MASTER_DEACTIVATED: 'master-data.entity-deactivated',
    MASTER_BULK_IMPORT_COMPLETED: 'master-data.bulk-import-completed',
};
exports.masterDeactivatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    entityType: zod_1.z.string(),
    entityId: zod_1.z.string().uuid(),
});
exports.masterBulkImportCompletedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    entityType: zod_1.z.string(),
    totalRows: zod_1.z.number().int(),
    createdCount: zod_1.z.number().int(),
    failedCount: zod_1.z.number().int(),
});
//# sourceMappingURL=master-data.events.js.map